import {atom} from 'jotai'
import {Transaction, TransactionDetail} from 'src/feature/transaction/domain'

const transaction: Transaction = {
  response: {
    transaction: {
      customerID: '',
      no: '',
      date: '',
      totalAmount: 0,
      storeNo: '',
      posNo: '',
      cardNo: '',
      type: 0,
      barCode: '',
      couponCodes: '',
      detail: '',
      id: '',
      brand: '',
      returnedTransactionID: '',
      createdDate: '',
    },
  },
  responseResult: {
    result: false,
    exceptionDetail: '',
  },
}

const transactionDetail: TransactionDetail = {
  channel: 0,
  date: '',
  discountAmount: 0,
  orderId: '',
  pointEarned: 0,
  posNo: {},
  storeNo: '',
  terminalId: '',
  purchaseAmount: 0,
  paidAmount: 0,
  feeAmount: 0,
  totalAmount: 0,
  transactionId: '',
  type: 0,
  discountCampaigns: [],
  pointCampaigns: [],
  productDetails: [],
  paymentTypes: [],
}

export const transactionAtom = atom<Transaction>(transaction)
export const transactionDetailAtom = atom<TransactionDetail>(transactionDetail)
